export class ProjectList {
    public projectId: any;
    public projectName: any;
    public totalHrs: any;
    public activities = [];
    public showActivity: boolean;
    constructor(data: any, bu) {
        this.projectId = data.projectID ? data.projectID : '';
        this.projectName = data.projectname ? data.projectname : '';
        if (bu === 'accenture') {
            this.totalHrs = data.totalHrs.toFixed(1) || 0;
        }
        if (bu === 'ipdo' || bu === 'biologics' || bu === 'chinateam' || bu === 'aps') {
            if (!!data.totalHrs) {
                const totalHrsconvertValue = this.convertHoursToMins(data.totalHrs);
                this.totalHrs = this.convertMinsToHrsMins(totalHrsconvertValue);
            }
            this.activities = data.activity_hrs ? data.activity_hrs : [];
            this.activities.forEach(element => {
                const totalHrsconvertValue = this.convertHoursToMins(element.FilledHrs);
                element.FilledHrs = this.convertMinsToHrsMins(totalHrsconvertValue);
            });
        }
        this.showActivity = data.showActivity ? data.showActivity : false;
    }

    convertHoursToMins(hrs) {
        const a = hrs.toString().split(':');
        let minutes = 0;
        if (a[1]) {
            minutes = (+(a[0])) * 60 + (+a[1]);
        } else {
            minutes = (+(Number(a[0]))) * 60;
        }
        return minutes;
    }

    convertMinsToHrsMins(mins) {
        const h: any = Math.floor(mins / 60);
        let m: any = mins % 60;
        m = Math.round(m);
        const hrs = h < 10 ? '0' + h : h;
        const mns = m < 10 ? '0' + m : m;
        return `${hrs}:${mns}`;
    }
}


// WEBPACK FOOTER //
// ./src/app/employee/project/project.ts